import pipe from "../../lib/core/functional/pipe";
import setUpInfiniteScrollLoadPage from "./infiniteScroll";
import setupButtonLoadPage from "./nextPage";

const pageLazyLoad = pipe(setUpInfiniteScrollLoadPage, setupButtonLoadPage);

export default pageLazyLoad;
